import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { updateCartProducts } from '@app/store/rtk.cart.store';

import ShopBody from '@components/pages/shop/partial/body';

import v2WrapperStyles from '@styles/wrapper';
import styles from '@v2/components/pages/shop/shop.styles';
import ProductService from '@v2/services/product.service';
import { setEntities } from '@app/store/rtk.entities.store';

export default function ShopPageBody() {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        ProductService.list()
            .then(data => {
                dispatch(setEntities(data));
                dispatch(updateCartProducts({ data }));
                setLoading(false);
            })
            .catch(console.error);
    }, []);

    return (
        <div className={[v2WrapperStyles.v2Global, styles.pageContainer].join(' ')}>
            <ShopBody loading={loading} />
        </div>
    );
}
